var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"height":"70vh","width":"100vw","position":"absolute","top":"0","z-index":"3"},on:{"click":function($event){return _vm.toggleVideo()}}}),_c('video',{staticClass:"one-player",attrs:{"id":"player-container-id","preload":"auto","playsinline":"","webkit-playsinline":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }